import { get as _get } from 'lodash';
import { v4 as uuid } from 'uuid';

// Check if mock mode is enabled
function isMockModeEnabled(): boolean {
  return !!(process.env.MOCK_CLAIMS_TYPE || process.env.NX_MOCK_CLAIMS_TYPE);
}

export function getContextRouterURL(region: string): string {
  switch (region) {
    case 'int':
      return 'https://digitalclaims-context-router-int-preprod.amfam.com/v1/validate';
    case 'dev':
      return 'https://digitalclaims-context-router-dev-sbx.amfam.com/v1/validate';
    case 'prod':
    case 'prd':
      return 'https://digitalclaims-context-router.amfam.com/v1/validate';
    case 'local':
      return 'https://digitalclaims-context-router-dev-sbx.amfam.com/v1/validate';
    default:
      return 'https://digitalclaims-context-router-dev-sbx.amfam.com/v1/validate';
  }
}

export function getRegion(): string {
  if (isMockModeEnabled()) {
    return 'local';
  }

  const hostname = window.location.hostname;
  let region = '';

  if (hostname === 'post-fnol.amfam.com') {
    region = 'prd';
  } else if (hostname === 'localhost.amfam.com') {
    region = 'dev';
  } else {
    const hostArr = hostname.split('.');
    if (hostArr[0].includes('-')) {
      const splitStr = hostArr[0].split('-');
      region = splitStr[_get(splitStr, 'length', 1) - 1];
    }
  }
  sessionStorage.setItem('originalURIREGION', region);
  return region;
}

export async function getQueryString() {
  // If in mock mode, return mock query parameters
  if (isMockModeEnabled()) {
    console.log('🔧 Mock Mode: Using mock URL query parameters');
    return {
      urlKey: 'mock-url-key-' + uuid(),
      custKey: 'mock-cust-key-' + uuid(),
      context: 'POST_FNOL_V2',
      callingSubContext: 'claims-overview',
    };
  }

  // Otherwise, use real URL parsing
  const pairs = window.location.search.substring(1).split('&');
  const result = {};
  pairs.forEach(function (pair) {
    const pairArray = pair.split('=');
    (result as any)[pairArray[0]] = decodeURIComponent(pairArray[1]);
  });
  return JSON.parse(JSON.stringify(result));
}
